import { Component } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface SurveySubmissionModel {
	title:string;
    submission:any;
}

@Component({  
    selector: 'survey-submission-modal',
    templateUrl: './survey-submission.html',
    styleUrls: ['./survey-submission.scss']
})

export class SurveySubmissionModalComponent extends DialogComponent<SurveySubmissionModel, any> implements SurveySubmissionModel {
  	title:string;
    submission:any;

  	constructor(
        dialogService: DialogService
    ) {
    	super(dialogService);
  	}
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/survey-submission/survey-submission.component.ts